import React from 'react'
import Lottie from 'react-lottie'
import { css } from 'styled-components'

import animationData from './animationData.json'

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

const GroupPreviewAnimation = () => (
  <Lottie
    options={defaultOptions}
    className={css`
      height: 547px;
      width: 272px;
    `}
  />
)

export default GroupPreviewAnimation
